import { MultiSelect } from "react-multi-select-component";
import { FieldHookConfig, useField, useFormikContext } from "formik";
import { OptionModel } from "../../../common/types/OptionModel";
import styled from "@emotion/styled";

const StyledMultiSelect = styled(MultiSelect)`
  .dropdown-heading {
    height: 32px !important;
  }
  .dropdown-heading-value {
    height: 32px !important;
    display: flex;
    align-items: center; 
  }
`;


type SelectorProps = {
  isMulti?: boolean;
  valueWidth?: number;
  onChange?: (name: string, value: string) => void;
  name?: string;
  defaultValue?: OptionModel[];
  value?: OptionModel[] | any;
  options: OptionModel[] | any;
  label?: string;
  definition?: string;
  required?: boolean;
  placement?: "auto" | "bottom" | "top";
  placeholder?: string | any;
  isSearchable?: boolean;
  classNamePrefix?: string;
  className?: string;
  menuPortalTarget?: HTMLElement;
  isDisabled?: boolean;
  formSelectorRef?: any;
  isClearable?: boolean;
  id?: string;
  labelHelper?: string;
  successText?: string;
  loading?: boolean;
};

export default function FormMultiSelect(props: SelectorProps & FieldHookConfig<string | any> & any) {
  const [field, meta, helpers] = useField(props);
  const { setFieldValue, setFieldTouched } = useFormikContext();

  const customStyles = {
    control: (base: any, state: any) => ({
      ...base,
      background: props.isMulti ? "#FFFFF" : "#E8EBEF",
      textColor: "#263445",
      borderColor: state.isFocused ? "#8D97A4" : "#E8EBEF",
      border: state.isFocused ? "2px solid #0287EF" : "",
      height: 36,
      minHeight: 36,
      padding: "0",
      boxShadow: state.isFocused ? null : null,
    }),
    valueContainer: (provided: any, state: any) => ({
      ...provided,
      height: "33px",
      padding: "0 6px",
      width: props.valueWidth ? props.valueWidth : "100%",
    }),
  };

  const onChange = (selectedOptions: OptionModel[]) => {
    setFieldValue(field.name, selectedOptions);
  };

  const onBlur = () => {
    setFieldTouched(field.name, true);
  };

  return (
    <div className="w-full">
      {props.label && (
        <div className="flex items-center text-sm mb-1">
          <label className="block text-contrast-70 whitespace-nowrap cursor-default">
            {props.label}
          </label>
          {props.definition && (
            <p className="block text-contrast-70 text-darkblue-400 whitespace-nowrap ml-1">
              ({props.definition})
            </p>
          )}
          {props.required && <p className="block text-contrast-70">*</p>}
        </div>
      )}
      <div className="text-sm rounded-md leading-3 mr-2 w-full">
        <StyledMultiSelect
          disabled={props.isDisabled ? true : false}
          hasSelectAll
          onChange={onChange}
          options={props.options}
          value={field.value}
          labelledBy={props.placeholder}
          overrideStrings={{
            "allItemsAreSelected": "Tümü.",
            "clearSearch": "Temizle",
            "clearSelected": "Seçilenleri Kaldır",
            "noOptions": props.loading ? 'Yükleniyor...' : 'Veri Yok',
            "search": "Ara",
            "selectAll": "Tümünü Seç",
            "selectAllFiltered": "Tümünü Seç (Filtreli)",
            "selectSomeItems": props.placeholder,
            "create": "Oluştur",
          }}
        />
      </div>
      {props.labelHelper && (
        <p className="mt-2 text-2xs text-contrast-70">{props.labelHelper}</p>
      )}
      {meta.touched && meta.error && (
        <p className="mt-2 text-sm text-error-text">{meta.error}</p>
      )}
      {props.successText && (
        <p className="mt-2 text-sm success-text">{props.successText}</p>
      )}
    </div>
  );
}
